module.exports = __webpack_public_path__ + "static/media/sgs_test.76346744.76346744.jpg";